import templateUrl from './massia.default.filters.modal.tpl.html';

import MassiaDefaultFiltersModalController from './massia.default.filters.modal.controller';

export default class MassiaDefaultFiltersController {
	static $inject = ['$uibModal', 'MassiaAuthService', '$rootScope', 'MassiaSelectService', 'MouvementStockService', '$sce'];

	constructor($uibModal, MassiaAuthService, $rootScope, MassiaSelectService, MouvementStockService, $sce) {
		this.$uibModal = $uibModal;
		this.MassiaAuthService = MassiaAuthService;
		this.$rootScope = $rootScope;
		this.MassiaSelectService = MassiaSelectService;
		this.MouvementStockService = MouvementStockService;
		this.$sce = $sce;
	}

	$onInit() {
		this._updateTooltip();
		this._loadSavedFilters();
	}

	_getStorageKey() {
		const user = this.MassiaAuthService.getAuthenticatedUser();
		const userId = user && (user.id || user.userId || user.login);
		return `massia_default_filters_${userId}`;
	}

	async _loadSavedFilters() {
		const key = this._getStorageKey();
		const saved = localStorage.getItem(key);
		if (saved) {
			try {
				const data = JSON.parse(saved);
				if (data && data.idSociete > 0) {
					this.selectedSocieteLabel = this._extractLibelle(data.societeLibelle);
					this.selectedSiteLabel = this._extractLibelle(data.siteLibelle);
					this._updateTooltip();
					this.$rootScope.$broadcast('massiaDefaultFiltersChanged', data);
					// L'utilisateur a déjà fait un choix explicite (même vide) : on ne surcharge pas
					return;
				}
			} catch (e) {
				// ignore
			}
		}
		try {
			const societes = await this.MassiaSelectService.getSocietesCom();
			if (societes && societes.length == 1) {
				const sites = await this.MassiaSelectService.getSitesCom(societes[0].id);
				if (sites && sites.length == 1) {
					const idRegoupement = await this.getRegroupement(societes[0].id, sites[0].id);
					const data = {
						idSociete: societes[0].id,
						societeLibelle: societes[0].libelle,
						idSite: sites[0].id,
						siteLibelle: sites[0].libelle,
						idRegroupementSite: idRegoupement
					};
					this.selectedSocieteLabel = this._extractLibelle(societes[0].libelle);
					this.selectedSiteLabel = this._extractLibelle(sites[0].libelle);
					this._updateTooltip();

					localStorage.setItem(key, JSON.stringify(data));
					this.$rootScope.$broadcast('massiaDefaultFiltersChanged', data);
				}
			}
		} catch (e) {
			// ignore
		}
	}

	async getRegroupement(idSociete, idSite) {
		let idRegroupementSite = 0;
		if (idSite && idSite > 0) {
			const regroupementsSite = await this.MouvementStockService.getRegroupementSites(idSociete);
			const regroupement = regroupementsSite.find((r) => {
				return r.sites.find((s) => {
					return s.id == idSite;
				});
			});
			idRegroupementSite = regroupement ? regroupement.id : 0;
		}
		return idRegroupementSite;
	}

	_updateTooltip() {
		const societe = this.selectedSocieteLabel || 'Toutes sociétés';
		const site = this.selectedSiteLabel || 'Tous sites';
		this.tooltipHtml = this.$sce.trustAsHtml(`${societe}<br>${site}`);
	}

	_extractLibelle(label) {
		if (!label) return '';
		const parts = label.split(' | ');
		return parts.length > 1 ? parts.slice(1).join(' | ') : label;
	}

	openModal() {
		const modalInstance = this.$uibModal.open({
			animation: true,
			size: 'md',
			backdrop: false,
			template: templateUrl,
			controllerAs: '$ctrl',
			controller: MassiaDefaultFiltersModalController,
			resolve: {
				storageKey: () => this._getStorageKey()
			}
		});

		modalInstance.result.then((data) => {
			this.selectedSocieteLabel = this._extractLibelle(data.societeLibelle);
			this.selectedSiteLabel = this._extractLibelle(data.siteLibelle);
			this._updateTooltip();
			this.$rootScope.$broadcast('massiaDefaultFiltersChanged', data);
		});
	}
}
